var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.is_api
    ? _c(
        "div",
        [
          _c(
            "b-tabs",
            { attrs: { pills: "", card: "", vertical: "" } },
            [
              _c(
                "b-tab",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "fs-lg px-4 text-center" },
                              [_vm._v(_vm._s(_vm.__t("MAIN_QR")))]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1200111457
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "p-3" },
                    [
                      _vm.is_load_url
                        ? _c("qr_code", {
                            key: "sss",
                            attrs: {
                              url: _vm.base_url_menu,
                              color: "#000000",
                              bgColor: "#ffffff",
                              size: 250,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.sections, function (section, sidx) {
                return _c(
                  "b-tab",
                  {
                    key: sidx,
                    attrs: { active: section.is_active },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fs-lg px-4 text-center d-flex justify-content-between align-items-center",
                                },
                                [
                                  _c("span", { staticClass: "flex-grow-1" }, [
                                    _vm._v(_vm._s(section.name)),
                                  ]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tables" },
                      [
                        _c(
                          "b-container",
                          { staticClass: "bv-example-row" },
                          [
                            _c(
                              "b-row",
                              _vm._l(section.tables, function (table, index) {
                                return _c(
                                  "b-col",
                                  {
                                    key: "col_" + table.id,
                                    attrs: { sm: "4", xl: "4", xs: "2" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "table_name" },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(table.name) +
                                            "\n                                "
                                        ),
                                        _c("qr_code", {
                                          key: "qr_" + table.id,
                                          attrs: {
                                            uniq_ref: "qr_table_" + table.id,
                                            url:
                                              _vm.base_url +
                                              "/" +
                                              table.uniq_id,
                                            color: "#000000",
                                            bgColor: "#ffffff",
                                            size: 250,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }